var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1239_5093",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1239_5093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 14.6667C7.07745 14.6667 6.21079 14.4916 5.39967 14.1413C4.58856 13.7916 3.88301 13.3167 3.28301 12.7167C2.68301 12.1167 2.20812 11.4111 1.85834 10.6C1.50812 9.7889 1.33301 8.92223 1.33301 8.00001C1.33301 7.07779 1.50812 6.21112 1.85834 5.40001C2.20812 4.5889 2.68301 3.88334 3.28301 3.28334C3.88301 2.68334 4.58856 2.20823 5.39967 1.85801C6.21079 1.50823 7.07745 1.33334 7.99967 1.33334C8.9219 1.33334 9.78856 1.50823 10.5997 1.85801C11.4108 2.20823 12.1163 2.68334 12.7163 3.28334C13.3163 3.88334 13.7912 4.5889 14.141 5.40001C14.4912 6.21112 14.6663 7.07779 14.6663 8.00001C14.6663 8.92223 14.4912 9.7889 14.141 10.6C13.7912 11.4111 13.3163 12.1167 12.7163 12.7167C12.1163 13.3167 11.4108 13.7916 10.5997 14.1413C9.78856 14.4916 8.9219 14.6667 7.99967 14.6667ZM11.333 6.33334L12.233 6.03334L12.4997 5.13334C12.1441 4.60001 11.7163 4.14157 11.2163 3.75801C10.7163 3.3749 10.1663 3.0889 9.56634 2.90001L8.66634 3.53334V4.46668L11.333 6.33334ZM4.66634 6.33334L7.33301 4.46668V3.53334L6.43301 2.90001C5.83301 3.0889 5.28301 3.3749 4.78301 3.75801C4.28301 4.14157 3.85523 4.60001 3.49967 5.13334L3.76634 6.03334L4.66634 6.33334ZM3.96634 11.4667L4.73301 11.4L5.23301 10.5L4.26634 7.60001L3.33301 7.26668L2.66634 7.76668C2.66634 8.4889 2.76634 9.14712 2.96634 9.74134C3.16634 10.336 3.49967 10.9111 3.96634 11.4667ZM7.99967 13.3333C8.28856 13.3333 8.5719 13.3111 8.84967 13.2667C9.12745 13.2222 9.39967 13.1556 9.66634 13.0667L10.133 12.0667L9.69967 11.3333H6.29967L5.86634 12.0667L6.33301 13.0667C6.59967 13.1556 6.8719 13.2222 7.14967 13.2667C7.42745 13.3111 7.71079 13.3333 7.99967 13.3333ZM6.49967 10H9.49967L10.433 7.33334L7.99967 5.63334L5.59967 7.33334L6.49967 10ZM12.033 11.4667C12.4997 10.9111 12.833 10.336 13.033 9.74134C13.233 9.14712 13.333 8.4889 13.333 7.76668L12.6663 7.30001L11.733 7.60001L10.7663 10.5L11.2663 11.4L12.033 11.4667Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootball);
export default __webpack_public_path__ + "static/media/football.2c2055f248c8801e5e5226bd7614134e.svg";
export { ForwardRef as ReactComponent };